<template>
  <div
    ref="root"
    class="layout-list"
    :class="[
      getGapClass('layout-list'),
      getHorizontalAlignClass('layout-list'),
      paddingClass,
    ]"
  >
    <slot />
  </div>
</template>

<script setup>
import { useLayout, layoutProps } from './useLayout.js';
import { ref } from 'vue';

const props = defineProps(layoutProps);
const root = ref(null);

const { getGapClass, getHorizontalAlignClass, paddingClass } = useLayout(
  props,
  root,
);
</script>
